import { css } from "@emotion/react"
import { shimmer } from "@mkt/ui/styles/Keyframes"

const shimmerMixin = css`
  animation-duration: 2.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${shimmer};
  animation-timing-function: linear;
  background: #ddd;
  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);
  background-size: 1200px 100%;
`

export const skeletonContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  max-width: 430px;
  width: 100%;
  margin: 0 auto;
`

export const titleLine = css`
  ${shimmerMixin}
  height: 24px;
  width: 80%;
  margin-bottom: 40px;
  border-radius: 20px;
`
export const textLine = css`
  ${shimmerMixin}
  align-self: flex-start;
  height: 8px;
  width: 45%;
  margin-bottom: 24px;
  border-radius: 8px;
`
export const labelLine = css`
  ${shimmerMixin}
  align-self: flex-start;
  height: 14px;
  width: 30%;
  margin-bottom: 8px;
  border-radius: 8px;
`
export const inputLine = css`
  ${shimmerMixin}
  height: 48px;
  width: 100%;
  margin-bottom: 25px;
  border-radius: 4px;
`

const gridLayout = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
`

export const buttonGroup = css`
  ${gridLayout}
`

export const inputGroup = css`
  ${gridLayout}
`

export const buttonLine = css`
  ${shimmerMixin}
  height: 48px;
  width: 100%;
  border-radius: 4px;
`
